import { AgentProviders, ChannelType } from '~/constants';

import {
  setEchoAgent as setEchoAgentAction,
  setEchoChannel as setEchoChannelAction,
} from '~/actions/global';

export const setEchoAgent = () => (dispatch, getState) => {
  const state = getState();

  const {
    channel_manager: { agents },
  } = state;

  const echoAgentID = agents.find(
    ({ provider }) => provider === AgentProviders.ECHO
  )?.id;

  dispatch(setEchoAgentAction(echoAgentID));
};
export const setEchoChannel = () => (dispatch, getState) => {
  const state = getState();

  const {
    channel_manager: { channels },
  } = state;

  const echoChannelID = channels.find(
    ({ type }) => type === ChannelType.ECHO
  )?.id;

  dispatch(setEchoChannelAction(echoChannelID));
};
